<template>
  <Modal :id="'cmp-accounting-costs-cost-split-add'" @cancelled="onCancel">
    <template slot="header">{{$t('new_cost_split')}}</template>

    <template slot="body">
      <div class="item-container">
        <button
          class="dt-button v1 s6"
          @click="onAddClick('cost_split_release')"
        >
          {{ $t("release") }}
        </button>
        <button
          class="dt-button v1 s6"
          @click="onAddClick('cost_split_product')"
        >
          {{ $t("products") }}
        </button>
        <button
          class="dt-button v1 s6"
          @click="onAddClick('cost_split_booking')"
        >
          {{ $t("booking") }}
        </button>
        <button class="dt-button v1 s6" @click="onAddClick('cost_split_tour')">
          {{ $t("tour") }}
        </button>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
    </template>
  </Modal>
</template>

<!-- <template>
  <v-card class="dt-modal accounts-cost-split-add">
    <div class="dt-modal--body">
      <div class="box-widget selected">
        <div class="box-header gray">
          <div class="box-header--name">New Cost Split</div>
        </div>
        <div class="box-body">
          <v-layout column align-center align-content-center class="add-types">
            <v-flex>
              <button class="dt-button v2" @click.stop="onClickedRelease">Release</button>
            </v-flex>
            <v-flex>
              <button class="dt-button v2" @click.stop="onClickedProduct">Product</button>
            </v-flex>
            <v-flex>
              <button class="dt-button v2" @click.stop="onClickedBooking">Booking</button>
            </v-flex>
            <v-flex>
              <button class="dt-button v2" @click.stop="onClickedTour">Tour</button>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
    <div class="dt-modal--options">
      <v-layout row wrap>
        <v-flex md6 xs12 offset-md6 class="text-md-right">
          <button class="dt-button v1" @click.stop="onCancel">{{$t('cancel')}}</button>
        </v-flex>
      </v-layout>
    </div>

 <v-dialog v-model="isReleaseModal" persistent width="850">
      <CostSplitRelease
        :release-data="costSplitAddReleases"
        :invoiceID="invoiceID"
        @addedNew="onAddedNewCostSplit"
        @cancelled="isReleaseModal = false"
      />
    </v-dialog>

    <v-dialog v-model="isProductModal" persistent width="850">
      <CostSplitProduct
        :product-data="costSplitAddProducts"
        :invoiceID="invoiceID"
        @addedNew="onAddedNewCostSplit"
        @cancelled="isProductModal = false"
      />
    </v-dialog>

    <v-dialog v-model="isBookingModal" persistent width="850">
      <CostSplitBooking
        :booking-data="costSplitAddBookings"
        :invoiceID="invoiceID"
        @addedNew="onAddedNewCostSplit"
        @cancelled="isBookingModal = false"
      />
    </v-dialog>

    <v-dialog v-model="isTourModal" persistent width="850">
      <CostSplitTour
        :tour-data="costSplitAddTours"
        :invoiceID="invoiceID"
        @addedNew="onAddedNewCostSplit"
        @cancelled="isTourModal = false"
      />
    </v-dialog> 
  </v-card>
</template> -->

<script>
import { mapGetters, mapActions } from "vuex";
import { mapKeyToAction } from "../../../../store/global";
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { createNTableConfig } from "../../../../plugins/datatable";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import Modal from "../../../../dt-plugins/modal/modal";

export default {
  components: {
    Modal,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      isReleaseModal: false,
      isProductModal: false,
      isBookingModal: false,
      isTourModal: false,
      invoiceTableConfig: createNTableConfig({
        headerStyle: 2,
        height: "250px",
      }),
      balances: [],
      newAddedBalanceID: 0,
      balanceAmountSum: 0,
    };
  },
  mounted: function () {},

  watch: {},
  computed: {
    // ...mapGetters(storeNS, {
    //   costSplitAddReleases: "costSplitAddReleases",
    //   costSplitAddProducts: "costSplitAddProducts",
    //   costSplitAddBookings: "costSplitAddBookings",
    //   costSplitAddTours: "costSplitAddTours",
    //   client: "clientObj"
    // }),
    costSplitID: function () {
      return this.$route.query.cost_split_id;
    },
    invoiceID: function () {
      return this.$route.query.invoice_id;
    },

    clientDefaultCurrency: function () {
      return this.client ? this.client.default_currency : "";
    },
  },
  methods: {
    // ...mapKeyToAction(storeNS, [
    //   ActionTypes.CostSplitAddReleases.SET.SINGLE,
    //   ActionTypes.CostSplitAddProducts.SET.SINGLE,
    //   ActionTypes.CostSplitAddBookings.SET.SINGLE,
    //   ActionTypes.CostSplitAddTours.SET.SINGLE,
    //   ActionTypes.SelectedCostAssignProjects.SET.SINGLE
    // ]),
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onClickedRelease() {
      this.isReleaseModal = true;
      this[ActionTypes.CostSplitAddReleases.SET.SINGLE](this.invoiceID);
    },

    onClickedProduct() {
      this.isProductModal = true;
      this[ActionTypes.CostSplitAddProducts.SET.SINGLE](this.invoiceID);
    },

    onClickedBooking() {
      this.isBookingModal = true;
      this[ActionTypes.CostSplitAddBookings.SET.SINGLE](this.invoiceID);
    },

    onClickedTour() {
      this.isTourModal = true;
      this[ActionTypes.CostSplitAddTours.SET.SINGLE](this.invoiceID);
    },

    updateRowPropValue(rowsVarName, rowKey, rowKeyVal, propName, propNewValue) {
      let rows = this[rowsVarName];
      this[rowsVarName] = rows.map((row) => {
        if (row[rowKey] == rowKeyVal) {
          row[propName] = propNewValue;
        }
        return row;
      });
    },

    onCancel() {
      this.$emit("cancelled");
    },

    onAddedNewCostSplit() {
      this[ActionTypes.SelectedCostAssignProjects.SET.SINGLE]({
        invoice_id: this.invoiceID,
      });
      this.onCancel();
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-cost-split-add {
  .item-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .s6 {
      margin: 10px;
    }
  }
}
</style>
